<template>
    <div class="cart columns">
        <i class="fas fa-times fa-2x left-upper-corner pointer" name="upperCornerIcon" id="upperCornerIcon" @click="HideCart"/>
        <h4 class="uppercase my-cart">Mi Carrito</h4>
        <div class="buttons-container header-buy-button" v-if="order.transactionMatrix && order.transactionMatrix.length !== 0">
                <button class="ui blue button wide" @click="Confirm()">Comprar ahora</button>
        </div>
        <!-- Contains the cart products -->
        <div class="cart-items">
            <!-- Only show if there are items in the cart -->
            <div v-if="order.transactionMatrix && order.transactionMatrix.length !== 0">
                <div class="cart-item" v-for="cartEntry in order.transactionMatrix.filter( ( tm ) => tm.type === 'PRODUCT_ENTRY' )" :key="cartEntry.product.id" :value="cartEntry">
                    <img class="cart-box-img" :src="`https://images.gofarma.com.mx/${cartEntry.product.sku}-1.jpeg`" onerror="this.src='https://images.gofarma.com.mx/fallback.jpeg';">
        
                    <div class="cart-product-info">
                        <div class="number-input">
                            <button @click="AddRawProduct( {product: cartEntry.product, quantity: (cartEntry.delta - 1)})">-</button>
                            <input class="input-delta" type='number' v-bind:value='cartEntry.delta' pattern="{1,99}" style="width: 4em;" disabled />
                            <button @click="AddRawProduct( {product: cartEntry.product, quantity: (cartEntry.delta +1)})">+</button>
                        </div>
                        <div class="word-wrap cart-product-name">
                            <p class="item-description">{{cartEntry.product.name}}</p>
                            <p class="bold text-start product-amount"><b>{{ (cartEntry.amount + cartEntry.amountTax) | to-currency-from-cents}} c/u</b></p>
                            <button class="ui danger button wide" @click="AddRawProduct( {product: cartEntry.product, quantity: (cartEntry.delta * -1)})">Eliminar de carrito</button>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else>
                <h5>No hay items en el carrito</h5>
            </div>
        </div>

        <!-- Contains the total and other actions-->
        <div class="wide cart-footer">
            <div class="cart-total row center">
                <div class="cart-info">
                    SUBTOTAL
                </div> 
                <div class="cost-info">
                    <b class="bold text-start">{{orderTotals.total - orderTotals.discounts | to-currency-from-cents}}</b>
                </div>
            </div>
            <div class="cart-total row center">
                <div class="cart-info">
                    DESCUENTO
                </div>
                <div class="cost-info">
                    <b class="bold text-start">{{orderTotals.discounts | to-currency-from-cents}}</b>
                </div>
            </div>
            <div class="cart-total row center bottom-padding">
                <div class="cart-info">
                    Total
                </div>
                <div class="cost-info">
                    <b class="bold text-start">{{orderTotals.total | to-currency-from-cents}}</b>
                </div>
            </div>
            <div class="buttons-container" v-if="order.transactionMatrix && order.transactionMatrix.length !== 0">
                <router-link to="/confirmar-compra">
                    <button class="ui blue button wide" @click="Confirm">Comprar ahora</button>
                </router-link>
            </div>
            <div class="buttons-container">
                <button type ="button" class="ui default button wide" @click="HideCart">Seguir comprando</button>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
export default {
    name:'Cart',
    methods:{
        HideCart(){
            let showCart = false
            this.$store.dispatch('SetAppScrollLock', showCart)
            this.$store.commit('StateAssign',{showCart})
        },
        Confirm(){
            let showCart = false
            this.$store.dispatch('SetAppScrollLock', showCart)
            this.$store.commit('StateAssign',{showCart})
            this.$store.dispatch('RouterPush', 'confirmar-compra')
        },
        ...mapActions(['AddRawProduct','RouterPush'])
    },
    computed:{
        ...mapState([
            'currentCustomer',
            'loginFromCart',
            'showCart',
            'order',
            'orderTotals'
        ])
    }
}

</script>
<style scoped>
    @import '../variables.css';
    i.fa-times {
        color: var(--gray-gofarma)!important;
        position: absolute;
        top: 0.3125rem;
        right: 0.3125rem;
        z-index: 99999999999;
    }
    .cart-info{
        width: 40%;
        text-align: left;
        padding-left: 1rem;
    }

    .cart-product-info{
        max-width: 50%;
        padding-left: 2em;
    }

    .cart-product-name{
        max-width: 100%
    }

    .my-cart{
        text-align: start; 
        padding-left: 30px; 
        margin-top:2em;
    }

    .cost-info{
        width: 60%;
        text-align: left;
    }

    .bottom-padding{
        padding-bottom:1rem;
    }
    .cart {
        background: #FAFAFA;
        position: fixed;
        width: 28%;
        min-width: 28%;
        top: 0;
        right: -100%;
        height: 100%;
        overflow-y: auto;
        box-shadow: 0 0 0.3125rem rgba(0, 0, 0, 1);
        -webkit-transition: right 0.5s; /* Safari */
        transition: right 0.5s;
        z-index: 99999999999;
        display: flex;
        flex-flow: column;
    }

    .cart-items{
        height: 100%;
        overflow: auto;
        padding: 2em;
    }

    .number-input{
        display: flex;
        flex-direction: row;
    }

    .cart.active {
        right: 0;
    }

    .buttons-container{
        width: 60%;
        margin: auto;
    }

    .cart-item {
        margin-top: 1rem;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: flex-start;
    }

    .cart-item img{
        width: 25%;
        height: 25%;
    }

    .main-container {
        overflow-y: auto;
        flex-basis: 80%;
    }

    .cart-box-img {
        width: 30%;
        height: 30%;
    }

    .cart-footer {
        flex-basis: 20%;
        background: #fafafa;
        padding-bottom:1rem;
        padding-top:1rem;
    }

    .cart-total {
        font-size: 1rem;
        padding-left: 0.625rem;
        justify-content: space-around;
        text-transform: uppercase;
    }

    .small-paddings {
        padding: 0.3125rem;
        box-sizing: border-box;
    }

    .cart .bottom {
        position: absolute;
        bottom: 0;
    }

    .ui.buy.button, .ui.buy.buttons .button {
        background-color: var(--light-blue);
        color: #fff;
        text-shadow: none;
        background-image: none;
        text-transform: uppercase;
    }

    .item-description{
        font-size: .9em;
        text-align: start;
    }

    p{
        margin:.5rem;
    }
    input[type=number]::-webkit-outer-spin-button,
    input[type=number]::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type=number] {
        -moz-appearance: textfield;
    }

    @media (max-width: 31.25rem){
        .ui.button, .cart-info, .cost-info, .item-description, .product-amount{
            font-size: .744rem
        }
        .header-buy-button{
            display: none;
        }
        .my-cart{
            margin-top:.5rem!important;
        }
        h4.uppercase.my-cart{
            margin:.5em;
        }
    }

</style>